import React from 'react';

import { ContributionSelection } from '~support-at-home/lib/contributionSelection';

import { Row } from '~components/table-view';
import ContributionSelectCheckbox, {
  SelectSlotPlaceholder,
} from '~support-at-home/components/config/contributions/ContributionSelectCheckbox';
import TruncatedText from '~support-at-home/components/config/contributions/TruncatedText';

interface ComponentProps {
  row: Row;
  selection?: ContributionSelection;
  isSelectable: boolean;
}

// A contribution's category, with the selection checkbox in the shared first column and the label indented.
// Called as a plain function from list.ts, like ContributionClientCell.
const ContributionCategoryCell = ({ row, selection, isSelectable }: ComponentProps) => {
  const categoryName = row?.category?.name ?? '';
  const id = String(row.id);
  const checked = !!selection?.selectedIds.has(id);

  return (
    <div className="contribution-category-cell d-flex align-items-center gap-2">
      {selection &&
        (isSelectable ? (
          <ContributionSelectCheckbox
            id={`sah-client-contributions-select-${id}`}
            label={`Select ${categoryName} contribution for ${selection.clientName(row.client_id)}`}
            checked={checked}
            anySelected={selection.selectedIds.size > 0}
            onChange={() => selection.onToggleContribution(id)}
          />
        ) : (
          <SelectSlotPlaceholder />
        ))}
      {/* Only the label is indented; the checkbox stays in the shared column at the cell's left edge. */}
      <TruncatedText text={categoryName} className="contribution-category" />
    </div>
  );
};

export default ContributionCategoryCell;
